<template>
  <div class="forget-passwd">
    <section-header class="mt-5 mb-5" title="忘記密碼？" subtitle="Forgot Password"/>
    <section class="pt-3 pb-5">
      <form class="needs-validation">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-12 text-center">
            <div class="title">重新設定密碼</div>
            <div class="desc text-secondary">輸入您的E-mail，請至信箱獲取重設密碼連結</div>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div class="col-lg-6 col-md-8 col-12">
            <div class="form-floating">
              <input id="input-email" type="email" class="form-control" :class="validation.email.class" placeholder="E-mail" maxlength="60" v-model="email">
              <label for="input-email" class="text-secondary">E-mail</label>
              <div class="invalid-feedback">{{ validation.email.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-4">
          <div class="col-lg-3 col-md-4 col-6">
            <button type="button" class="btn btn-lg btn-dark w-100" @click="onSubmitted" :disabled="loading">
              <i v-if="loading" class="spinner-border text-light btn-spinner"></i>
              <span v-else>送出</span>
            </button>
          </div>
          <div class="col-lg-3 col-md-4 col-6">
            <router-link to="/w/sign-in" class="btn btn-lg btn-secondary w-100">取消</router-link>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import authApi from '@/api/auth.js'
import SectionHeader from '@/components/SectionHeader.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'ForgetPasswd',
  components: {
    SectionHeader
  },
  data: function () {
    return {
      email: null,
      loading: false,
      validation: {
        email: { class: null, feedback: null }
      }
    }
  },
  watch: {
    email: function (value) {
      this.validation.email.class = null
    }
  },
  methods: {
    ...mapMutations([
      'setAlert'
    ]),
    apiSendResetPasswordMail: function () {
      this.loading = true
      var self = this
      authApi.sendResetPasswordMail(this.email, function (err, rspData) {
        self.loading = false
        if (err) {
          self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: '無法寄送重設密碼E-mail' })
          return
        }
        self.setAlert({ type: constant.ALERT_TYPE.INFO, msg: '已寄出重設密碼信件，請至E-mail信箱收信' })
      })
    },
    onSubmitted: function () {
      if (!this.email) {
        this.validation.email.class = 'is-invalid'
        this.validation.email.feedback = '請輸入您的E-mail'
        return
      } else if (!this.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        this.validation.email.class = 'is-invalid'
        this.validation.email.feedback = '不正確的E-mail格式'
        return
      } else {
        this.validation.email.class = 'is-valid'
      }
      this.apiSendResetPasswordMail()
    }
  }
}
</script>

<style scoped>
.title {
  font-family: 'Noto Serif TC', serif;
  font-size: 2rem;
  font-weight: 700;
}
</style>
